export default __webpack_public_path__ + "4bf4f882799c2678e67536955dbeabbf.png";